module.exports = __webpack_public_path__ + "static/media/pw.c62766dc.svg";